import { useMutation } from 'src/graphql';
import { OVERRIDE_SURVEY_RESPONSE_TYPE } from 'src/graphql/survey/mutation';
import { useCallback } from 'react';
import { notification } from 'src/components/Notification';

const useOverrideSurveyResponseType = () => {
  const [overrideSurveyResponseType] = useMutation(
    OVERRIDE_SURVEY_RESPONSE_TYPE,
    {                                             
      onError: (error) => {
      const errorMessage = error.graphQLErrors.map(function(item) {
        return item.message;
      });     
      notification.error(errorMessage.toString());
    }}
  );

  return useCallback(
    params => overrideSurveyResponseType({ variables: params }),
    [],
  );
};

export default useOverrideSurveyResponseType;
